import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractTabComponent } from '../common/abstracts/abstract-tab.component';
import { TabItem } from '../common/models/common.model';
import { RawMaterialWarehouse } from '../raw-material-inventory/raw-material.model';
import { RawMaterialService } from '../raw-material-inventory/raw-material.service';

export enum MasterTab {
  WAREHOUSES = 'warehouses',
  FACTORIES = 'factories',
  COMPANIES = 'companies',
  ROLES_AND_DESIGNATIONS = 'roles-and-designations',
}

@Component({
  selector: 'app-master',
  standalone: false,
  templateUrl: './master.component.html',
  styleUrl: './master.component.scss',
})
export class MasterComponent extends AbstractTabComponent implements OnInit {
  public override selectedTab: string = MasterTab.WAREHOUSES;

  public override tabs: TabItem[] = [
    {
      label: 'Warehouses',
      value: MasterTab.WAREHOUSES,
      icon: 'bi bi-building',
      permissionCode: 'ui_master.warehouses.view',
    },
    {
      label: 'Factories',
      value: MasterTab.FACTORIES,
      icon: 'bi bi-building-fill',
      permissionCode: 'ui_master.factories.view',
    },
    {
      label: 'Companies',
      value: MasterTab.COMPANIES,
      icon: 'bi bi-briefcase',
      permissionCode: 'ui_master.companies.view',
    },
    {
      label: 'Roles & Designations',
      value: MasterTab.ROLES_AND_DESIGNATIONS,
      icon: 'bi bi-person-badge',
      permissionCode: 'ui_master.roles.view',
    },
  ];

  protected wareHouses: RawMaterialWarehouse[] = [];

  constructor(
    private rawMaterialService: RawMaterialService,
    protected override route: ActivatedRoute,
    protected override router: Router
  ) {
    super(route, router);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.rawMaterialService.get_warehouses().subscribe({
      next: warehouses => (this.wareHouses = warehouses),
    });
  }

  protected readonly MasterTab = MasterTab;
}
